/**
 * Generates a unique name by appending an incremental number if the base name already exists.
 *
 * @param existingNames - Array of names that already exist
 * @param baseName - The base name to use (will append " 2", " 3", etc. if needed)
 * @returns A unique name that doesn't exist in the existingNames array
 */
export const getUniqueName = (existingNames: string[], baseName: string): string => {
  const nameSet = new Set(existingNames);

  if (!nameSet.has(baseName)) {
    return baseName;
  }

  let counter = 1;
  let candidate = `${baseName} ${counter}`;

  while (nameSet.has(candidate)) {
    counter++;
    candidate = `${baseName} ${counter}`;
  }

  return candidate;
};

export default getUniqueName;
